import {
  FETCH_FOOD_REQUEST,
  FETCH_FOOD_SUCCESS,
  FETCH_FOOD_FAILURE,
  CREATE_FOOD_REQUEST,
  CREATE_FOOD_SUCCESS,
  CREATE_FOOD_FAILURE,
  UPDATE_FOOD_REQUEST,
  UPDATE_FOOD_SUCCESS,
  UPDATE_FOOD_FAILURE,
  DELETE_FOOD_REQUEST,
  DELETE_FOOD_SUCCESS,
  DELETE_FOOD_FAILURE,
  UPLOAD_EXCEL_FOOD_REQUEST,
  UPLOAD_EXCEL_FOOD_SUCCESS,
  UPLOAD_EXCEL_FOOD_FAILURE
} from "./foodActionTypes";

const initialState = {
  loading: false,
  foodData: [],
  error: null,
};

const foodReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FOOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FOOD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        foodData: action.payload.data,
      };
    case FETCH_FOOD_FAILURE:
      return {
        ...state,
        loading: false,
        foodData: [],
        error: action.payload,
      };

    case CREATE_FOOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_FOOD_SUCCESS:
      return {
        ...state,
        loading: false,
        foodData: action.payload.data,
        error: null,
      };
    case CREATE_FOOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_FOOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_FOOD_SUCCESS:
      return {
        ...state,
        loading: false,
        foodData: action.payload.data,
        error: null,
      };
    case UPDATE_FOOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_FOOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_FOOD_SUCCESS:
      return {
        ...state,
        loading: false,
        foodData: action.payload.data,
        error: null,
      };
    case DELETE_FOOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
 case UPLOAD_EXCEL_FOOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPLOAD_EXCEL_FOOD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case UPLOAD_EXCEL_FOOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default foodReducer;
